<template>
  <div class="vibration-box">
    <!-- 文字内容区域 -->
    <div class="vibration-content">
      <p class="vibration-content-p1" ref="title">{{ $t('series.vibration') }}</p>
      <p class="vibration-content-p2" ref="subtitle">{{ $t('series.vibration_fast') }}</p>
      <p class="vibration-content-p3" ref="rpm">{{ $t('series.vibration_rpm') }}</p>
      <p class="vibration-content-p4" ref="description">
        {{ $t('series.vibration_desc') }}
      </p>
    </div>

    <!-- 图片区域 -->
    <div class="vibration-image">
      <img :src="src" ref="image">
    </div>
  </div>
</template>

<script>
import image1 from "../../static/series/vibrationbox.png"

export default {
  name: 'VibrationBox',
  data() {
    return {
      src: image1,
      isMobile: false,
      timeline: null
    }
  },
  mounted() {
    // 检测设备类型
    this.checkDeviceType();

    // 等待DOM渲染完成
    this.$nextTick(() => {
      this.initAnimations();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听和动画
    window.removeEventListener('resize', this.handleResize);
    if (this.timeline) {
      this.timeline.kill();
    }
    this.$ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger === '.vibration-box') {
        trigger.kill();
      }
    });
  },
  methods: {
    checkDeviceType() {
      // 检测是否为移动设备
      this.isMobile = window.innerWidth < 768;
    },
    handleResize() {
      // 窗口大小变化时重新检测设备类型并刷新动画
      const newIsMobile = window.innerWidth < 768;
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        if (this.timeline) {
          this.timeline.kill();
        }
        this.initAnimations();
        this.$ScrollTrigger.refresh();
      }
    },
    initAnimations() {
      this.$gsap.set('.vibration-content', {
        y: 300
      })
      this.$gsap.set('.vibration-image', {
        y: 100
      })

      // 创建主时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.vibration-box',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          toggleActions: 'play none none none',
          invalidateOnRefresh: true,
          once: true,
          // scrub: 1
        }
      })

      masterTimeline.to('.vibration-content', {
        y: 0,
        duration: 1.5,
        ease: 'power2.in'
      }, 0)

      masterTimeline.to('.vibration-image', {
        y: 0,
        duration: 1.5,
        ease: 'power2.in'
      }, 0)

    }
  }
}
</script>

<style scoped>
.vibration-box {
  background-color: black;
  width: 100%;
  padding: 60px 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.vibration-content {
  width: 65%;
  margin: 0 auto 0px;
  box-sizing: border-box;
}

.vibration-content p {
  text-align: left;
  margin-top: 0px;
  will-change: transform, opacity;
}

.vibration-content-p1 {
  color: white;
  font-size: 1.5em;
  margin-bottom: 20px;
}

.vibration-content-p2 {
  margin-top: 0px;
  font-size: 3em;
  background: linear-gradient(90deg, #66CCFF, #0066CC);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 0em;
}

.vibration-content-p3 {
  font-size: 2em;
  color: white;
  margin-bottom: 20px;
}

.vibration-content-p4 {
  font-size: 1.5em;
  color: #808080;
  max-width: 755px;
}

.vibration-image {
  width: 100%;
  text-align: center;
  padding: 20px 0;
}

.vibration-image img {
  width: 75%;
  height: auto;
  will-change: transform, opacity;
}

/* 手机端适配样式 - 更精细的断点控制 */
@media (max-width: 767px) {
  .vibration-box {
    padding: 40px 15px;
  }

  .vibration-content {
    margin-bottom: 40px;
    padding: 0 5px;
  }

  .vibration-content-p1 {
    font-size: 24px;
    margin-bottom: 0.6em;
  }

  .vibration-content-p2 {
    font-size: 2.2em;
    line-height: 1.1;
  }

  .vibration-content-p3 {
    font-size: 22px;
    margin-bottom: 1.2em;
  }

  .vibration-content-p4 {
    font-size: 1.1em;
    line-height: 1.6;
  }

  .vibration-image {
    padding: 10px 0;
  }

  .vibration-image img {
    width: 95%;
  }
}

/* 小屏手机额外适配 */
@media (max-width: 375px) {
  .vibration-content-p2 {
    font-size: 1.8em;
  }

  .vibration-content-p4 {
    font-size: 1em;
  }
}
</style>

